module.exports = __webpack_public_path__ + "media/images/favicon-958e99fd8e66559adcb4314487fa98da.png";